import { useRef, useState } from "react";
import { Upload, FileText, X } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export function FileUpload({ value, onChange, label = "File", accept = "application/pdf", testid = "file-upload" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/admin/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("File uploaded");
    } catch {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {label && <label className="block text-sm font-medium text-[#333333] mb-1">{label}</label>}
      <div className="flex items-center gap-3">
        {value ? (
          <div className="flex items-center gap-2 text-sm text-[#1E63C4] bg-blue-50 rounded-md px-3 py-2">
            <FileText className="h-4 w-4 shrink-0" />
            <span className="truncate max-w-[160px]">{value.split("/").pop()}</span>
            <button type="button" onClick={() => onChange("")} className="text-red-500" data-testid={`${testid}-remove`}>
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ) : (
          <span className="text-xs text-gray-400">No file</span>
        )}
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          data-testid={`${testid}-btn`}
          className="inline-flex items-center gap-2 text-sm border border-[#1E63C4] text-[#1E63C4] rounded-md px-3 py-2 hover:bg-blue-50 transition-colors disabled:opacity-60"
        >
          <Upload className="h-4 w-4" /> {busy ? "Uploading…" : "Upload"}
        </button>
        <input ref={inputRef} type="file" accept={accept} onChange={handleFile} className="hidden" />
      </div>
    </div>
  );
}
